const PlayIcon = ({ isDone }) => {
  return (
    <svg
      className="play-icon"
      width="54"
      height="54"
      viewBox="0 0 54 54"
      fill={isDone ? "#B3EB9C" : "white"}
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="27"
        cy="27"
        r="26.5"
        fill="#A7A7A7"
        fillOpacity="0.2"
        stroke={isDone ? "#B3EB9C" : "white"}
      />
      <path
        d="M22.819 18.6577C22.7037 18.5755 22.5679 18.5267 22.4267 18.5166C22.2855 18.5065 22.1442 18.5355 22.0183 18.6003C21.8924 18.6652 21.7868 18.7634 21.7131 18.8843C21.6393 19.0052 21.6002 19.144 21.6002 19.2856V34.7142C21.6002 34.8558 21.6393 34.9946 21.7131 35.1155C21.7868 35.2364 21.8924 35.3346 22.0183 35.3995C22.1442 35.4643 22.2855 35.4933 22.4267 35.4832C22.5679 35.473 22.7037 35.4242 22.819 35.3421L33.619 27.6278C33.719 27.5565 33.8005 27.4623 33.8568 27.353C33.913 27.2438 33.9423 27.1227 33.9423 26.9999C33.9423 26.877 33.913 26.756 33.8568 26.6467C33.8005 26.5375 33.719 26.4433 33.619 26.3719L22.819 18.6577Z"
        stroke={isDone ? "#B3EB9C" : "white"}
      />
    </svg>
  );
};

export default PlayIcon;
